var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D24F45",
    d: "M121.89 50.62a37.39 37.39 0 001.64-10.97c-.03-13.1-10.18-24.41-24.44-27.27-14.26-2.85-28.81 7.7-35.05 19.54-6.32-11.84-20.92-22.35-35.19-19.44-14.26 2.9-24.4 14.27-24.38 27.39a40.28 40.28 0 004.64 17 64.19 64.19 0 005.2 8.72c4.28 5.43 8.96 10.6 14.01 15.46 4.95 5.21 10.1 10.31 15.22 15.36a421.36 421.36 0 0018.84 17.76l2.2 1.92 2.15-1.92A541.05 541.05 0 0096.2 85.55a203.1 203.1 0 0017.18-18.48 51.68 51.68 0 008.5-16.45z"
  })));
}

export default SvgIconHeartFilled;